/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { Button } from "semantic-ui-react";
import { fetchNotifications, notificationUpdated, selectAllNotifications, selectNotificationsStatus } from "../slices/notifications/notificationsSlice";
import { useEffect, useState } from "react";
import { fetchSavedSearches, selectSavedSearchById } from "../slices/savedSearches/savedSearchesSlice";
import { changeSearchSettings } from "../slices/searchSettings/searchSettingsSlice";
import { useNavigate } from "react-router-dom";

const SearchResultNotificationDisplay = ({ notification }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const savedSearch = useSelector(state => selectSavedSearchById(state, notification.target));

    const [urlState, setUrlState] = useState("");

    useEffect(() => {
        if (savedSearch) {
            let url;
            if (savedSearch.source === "medline") {
                url = "/medlineconvert";
            } else if (savedSearch.source === "ctgov") {
                url = "/ctgovconvert";
            } else if (savedSearch.source === "fevir") {
                url = "/search";
            }
            setUrlState(url);
        }
    }, [savedSearch]);

    const modifySearchSettings = () => {
        let modifiedSearch = JSON.parse(JSON.stringify(savedSearch));
        if (!modifiedSearch.searchparameters) {
            modifiedSearch.searchparameters = {};
        }
        modifiedSearch.searchparameters.updatedSearchStartDate = notification.startdate;
        modifiedSearch.searchparameters.updatedSearchEndDate = notification.enddate;
        dispatch(changeSearchSettings(modifiedSearch));
        navigate(urlState);
        dispatch(notificationUpdated(
            {
                id: notification.id,
                uncleared: notification.uncleared,
                unread: false
            }
        ));
    }

    return <>
        {urlState &&
            <a onClick={() => { modifySearchSettings(); }}>{notification.message}</a>
        }
    </>
}

// eslint-disable-next-line no-empty-pattern
const NotificationsView = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const notifications = useSelector(state => selectAllNotifications(state));
    const notificationStatus = useSelector(state => selectNotificationsStatus(state));
    //notifications is an array of { id: string, userid: number, message: string, classifier: string, target: FOI, unread: boolean, uncleared: boolean, time: Date }

    useEffect(() => {
        dispatch(fetchNotifications(apiToken));
        dispatch(fetchSavedSearches());
    }, [apiToken])

    return <div>
        {notifications?.length > 0
            ?
            <div style={{ "textAlign": "left" }}>{notifications.map((notification, index) => {
                return <p key={index}>
                    {notification.uncleared ?
                        <>
                            <span style={{ fontWeight: notification.unread ? "bold" : "" }}>
                                {((notification.classifier === "resource-updated" ||
                                    notification.classifier === "referenced-resource-updated") &&
                                    notification.target) &&
                                    <a href={"/" + notification.target}
                                        onClick={() => {
                                            dispatch(notificationUpdated(
                                                {
                                                    id: notification.id,
                                                    uncleared: notification.uncleared,
                                                    unread: false
                                                }
                                            ));
                                        }}>{notification.message}</a>
                                }
                                {(notification.classifier === "search-has-results" &&
                                    notification.target) &&
                                    <SearchResultNotificationDisplay notification={notification} />
                                }
                                {(!
                                    ((notification.classifier === "resource-updated" ||
                                        notification.classifier === "referenced-resource-updated" ||
                                        notification.classifier === "search-has-results") &&
                                        notification.target)

                                ) &&
                                    notification.message
                                }
                            </span>
                            &nbsp;&nbsp;{notification.timeString}  <span>
                                <Button className="formButton"
                                    style={{ color: "#000000", padding: "4px" }}
                                    content={notification.unread ? "Mark Read" : "Mark Unread"}
                                    onClick={() => {
                                        dispatch(notificationUpdated(
                                            {
                                                id: notification.id,
                                                uncleared: notification.uncleared,
                                                unread: !notification.unread
                                            }
                                        ));
                                    }} />
                            </span>  <span>
                                <Button className="formButton"
                                    style={{ color: "#000000", padding: "4px" }}
                                    content="Remove"
                                    onClick={() => {
                                        dispatch(notificationUpdated(
                                            {
                                                id: notification.id,
                                                uncleared: false,
                                                unread: false
                                            }
                                        ));
                                    }} />
                            </span>
                        </>
                        :
                        "Notification deleted."}
                </p>
            })}</div>
            :
            <p>{notificationStatus === "succeeded" ? "You do not have any notifications." : "Loading..."}</p>
        }
    </div >
}

export default NotificationsView;